export function getQuery(arrayFields = []) {
  const queryString = window.location.search

  const params = new URLSearchParams(queryString)
  const result = {}

  arrayFields.forEach((item) => {
    result[item] = []
  })

  params.forEach((value, key) => {
    if (!key || !value) return

    if (result[key]) {
      if (Array.isArray(result[key])) {
        result[key].push(value)
      } else {
        result[key] = [result[key], value]
      }
    } else {
      result[key] = value
    }
  })

  return result
}

export function setRangeQuery(keys = [], dates = []) {
  if (!keys.length || !dates.length) return

  const url = new URL(window.location.href)
  const params = url.searchParams

  keys.forEach((key, index) => {
    if (!dates[index]) {
      params.delete(key)
    } else {
      const date = new Date(dates[index].getTime())
      date.setHours(0, 0, 0, 0)
      params.set(key, date.toISOString())
    }
  })

  window.history.pushState({}, '', url)
}

export function setQuery(newParams) {
  const urlObj = new URL(window.location.href)

  const newSearchParams = new URLSearchParams()

  Object.entries(newParams).forEach(([key, value]) => {
    if (value && Array.isArray(value)) {
      value.forEach((val) => {
        newSearchParams.append(key, val)
      })
    } else if (value) {
      newSearchParams.set(key, value)
    }
  })

  window.history.pushState(
    {},
    '',
    `${urlObj.pathname}?${newSearchParams.toString()}`
  )
}
